import { gql } from 'graphql-request';

export const CACHE_DELETE_INVOICE_CUSTOM_FIELD_QUERY = gql`
  mutation CacheDeleteInvoiceCustomField($uuid: ID!) {
    deleteInvoiceCustomField(input: { uuid: $uuid }) {
      errors {
        fullMessages
      }
      status
    }
  }
`;
